import i18n from '../../language/index'
import img_effects from '@/base/img_effects'
import { create_title } from '@/base/titleData';
import { box_shadow_style_add, getBackgroundData, getSwiperSettingData, font_set_add } from "@/base/widgets_data_compatible";
import pageData from '@/base/pageData'
export default {
  img_effects: {
    ...img_effects,
    id:1
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  pc_widgets_infor: {
    page:pageData,
    //图片高度 0 1
    img_size: {
      radio_val: 'default',
      default: {
        width: '100%',
        height: '90%',
      },
      custom: {
        width: '100%',
        height: '90%',
      }
    },
    // 图片大小 2
    pic_size: {
      radio_val: 'default',
      default: {
        width: '25%',
        height: '25%'
      },
      custom: {
        width: '25%',
        height: '25%'
      }
    },
    //图片缩放
    backgroundSize: {
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },
    title: create_title(i18n.t('widgets_basic_recommend_list_edit_2803')),
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },
    //每行间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: 20,
        paddingLeft: 20,
      },
      custom: {
        paddingTop: 20,
        paddingLeft: 20,
      }
    },
    // 跳转方式 _blank 新窗口 _self 当前窗口
    target: '_blank',
    // 组合阴影 添加
    ...box_shadow_style_add(),
    ...getBackgroundData(),
    ...getSwiperSettingData(),
    // 添加标题文字
    product_name_font: {
      ...font_set_add()
    },
    recommend_num:4, //推荐个数 默认4
  },
  mb_widgets_infor: {
    //标题对象
    title: create_title(i18n.t('widgets_basic_recommend_list_edit_2803')),
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 2,
      },
      custom: {
        value: 2,
      }
    },
    recommend_num:4, //推荐个数 默认4
  },
  listArr: {
    // type: 'custom',
    module_style: 0,
    
    types: [],
    catalog_id: ['200001'],
    type: 'systom'
  },
}


// WEBPACK FOOTER //
// ./src/widgets/basic_recommend_list/style.js